// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WisdomRouteImport } from './routes/wisdom'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as VisualsRouteImport } from './routes/visuals'
import { Route as TopicsRouteImport } from './routes/topics'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StartRouteImport } from './routes/start'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as MusicRouteImport } from './routes/music'
import { Route as MethodRouteImport } from './routes/method'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as MediaRouteImport } from './routes/media'
import { Route as MapRouteImport } from './routes/map'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as IntelligenceRouteImport } from './routes/intelligence'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as GatesRouteImport } from './routes/gates'
import { Route as EventsRouteImport } from './routes/events'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConstellationRouteImport } from './routes/constellation'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as CodexRouteImport } from './routes/codex'
import { Route as CirclesRouteImport } from './routes/circles'
import { Route as BooksRouteImport } from './routes/books'
import { Route as BlueprintRouteImport } from './routes/blueprint'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ActivationsRouteImport } from './routes/activations'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AcademyRouteImport } from './routes/academy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PressIndexRouteImport } from './routes/press.index'
import { Route as PlaylistsIndexRouteImport } from './routes/playlists.index'
import { Route as NewsIndexRouteImport } from './routes/news.index'
import { Route as ConceptsIndexRouteImport } from './routes/concepts.index'
import { Route as BeatsIndexRouteImport } from './routes/beats.index'
import { Route as VerifyCodeRouteImport } from './routes/verify.$code'
import { Route as ReleaseSlugRouteImport } from './routes/release.$slug'
import { Route as PressFactsheetRouteImport } from './routes/press.factsheet'
import { Route as PlaylistsIdRouteImport } from './routes/playlists.$id'
import { Route as NewsSlugRouteImport } from './routes/news.$slug'
import { Route as DebugSentryTestRouteImport } from './routes/debug.sentry-test'
import { Route as ConceptsSlugRouteImport } from './routes/concepts.$slug'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as BeatsLicenseRouteImport } from './routes/beats.license'
import { Route as BeatsCustomRouteImport } from './routes/beats.custom'
import { Route as BeatsCatalogRouteImport } from './routes/beats.catalog'
import { Route as BeatsSlugRouteImport } from './routes/beats.$slug'
import { Route as ArtistBuddhaKaRouteImport } from './routes/artist.buddha-ka'
import { Route as WisdomIndexRouteImport } from './routes/wisdom.index'
import { Route as WisdomSlugRouteImport } from './routes/wisdom.$slug'
import { Route as TopicsIndexRouteImport } from './routes/topics.index'
import { Route as TopicsSlugRouteImport } from './routes/topics.$slug'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopSlugRouteImport } from './routes/shop.$slug'
import { Route as NewsletterConfirmRouteImport } from './routes/newsletter.confirm'
import { Route as MusicIndexRouteImport } from './routes/music.index'
import { Route as MusicDiscographyRouteImport } from './routes/music.discography'
import { Route as MusicSlugRouteImport } from './routes/music.$slug'
import { Route as MethodIndexRouteImport } from './routes/method.index'
import { Route as MethodPillarRouteImport } from './routes/method.$pillar'
import { Route as MediaIndexRouteImport } from './routes/media.index'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as LibraryCategoryRouteImport } from './routes/library.$category'
import { Route as GatesIndexRouteImport } from './routes/gates.index'
import { Route as GatesMapRouteImport } from './routes/gates.map'
import { Route as GatesNRouteImport } from './routes/gates.$n'
import { Route as CodexIndexRouteImport } from './routes/codex.index'
import { Route as CodexSlugRouteImport } from './routes/codex.$slug'
import { Route as CirclesIndexRouteImport } from './routes/circles.index'
import { Route as CirclesSlugRouteImport } from './routes/circles.$slug'
import { Route as BooksIndexRouteImport } from './routes/books.index'
import { Route as BooksBibliographyRouteImport } from './routes/books.bibliography'
import { Route as BooksSlugRouteImport } from './routes/books.$slug'
import { Route as ActivationsIndexRouteImport } from './routes/activations.index'
import { Route as ActivationsWheelRouteImport } from './routes/activations.wheel'
import { Route as ActivationsCalendarRouteImport } from './routes/activations.calendar'
import { Route as ActivationsArchiveRouteImport } from './routes/activations.archive'
import { Route as ActivationsSlugRouteImport } from './routes/activations.$slug'
import { Route as AcademyIndexRouteImport } from './routes/academy.index'
import { Route as AcademyPremiumRouteImport } from './routes/academy.premium'
import { Route as AcademyLibraryRouteImport } from './routes/academy.library'
import { Route as AcademyGraphRouteImport } from './routes/academy.graph'
import { Route as AcademyDailyRouteImport } from './routes/academy.daily'
import { Route as AcademyCommunityRouteImport } from './routes/academy.community'
import { Route as AuthenticatedMeRouteImport } from './routes/_authenticated/me'
import { Route as AuthenticatedLibraryRouteImport } from './routes/_authenticated/library'
import { Route as AuthenticatedJourneyRouteImport } from './routes/_authenticated/journey'
import { Route as AuthenticatedDownloadsRouteImport } from './routes/_authenticated/downloads'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAskRouteImport } from './routes/_authenticated/ask'
import { Route as AuthenticatedAscensionRouteImport } from './routes/_authenticated/ascension'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as PressTheDiamondSutraIndexRouteImport } from './routes/press.the-diamond-sutra.index'
import { Route as PressReleasesIndexRouteImport } from './routes/press.releases.index'
import { Route as BeatsCollectionsIndexRouteImport } from './routes/beats.collections.index'
import { Route as PressTheDiamondSutraListenRouteImport } from './routes/press.the-diamond-sutra.listen'
import { Route as PressKitSlugRouteImport } from './routes/press.kit.$slug'
import { Route as BeatsCollectionsSlugRouteImport } from './routes/beats.collections.$slug'
import { Route as MusicSlugIndexRouteImport } from './routes/music.$slug.index'
import { Route as LibraryReadSlugRouteImport } from './routes/library.read.$slug'
import { Route as ActivationsSeriesSeriesRouteImport } from './routes/activations.series.$series'
import { Route as AcademyKafrequencyIndexRouteImport } from './routes/academy.kafrequency.index'
import { Route as AcademyDomainIndexRouteImport } from './routes/academy.$domain.index'
import { Route as AcademyDomainPathRouteImport } from './routes/academy.$domain.$path'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSettingsPrivacyRouteImport } from './routes/_authenticated/settings.privacy'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings.notifications'
import { Route as AuthenticatedSettingsMemoryRouteImport } from './routes/_authenticated/settings.memory'
import { Route as AuthenticatedBeatsAdminRouteImport } from './routes/_authenticated/beats.admin'
import { Route as AuthenticatedBeatsAccountRouteImport } from './routes/_authenticated/beats.account'
import { Route as AuthenticatedAcademySavedRouteImport } from './routes/_authenticated/academy.saved'
import { Route as AuthenticatedAcademyJournalRouteImport } from './routes/_authenticated/academy.journal'
import { Route as AuthenticatedAcademyDashboardRouteImport } from './routes/_authenticated/academy.dashboard'
import { Route as AuthenticatedAcademyAiGuideRouteImport } from './routes/_authenticated/academy.ai-guide'
import { Route as AuthenticatedJourneyIndexRouteImport } from './routes/_authenticated/journey.index'
import { Route as AuthenticatedJourneyTimelineRouteImport } from './routes/_authenticated/journey.timeline'
import { Route as AuthenticatedJourneyTempleRouteImport } from './routes/_authenticated/journey.temple'
import { Route as AuthenticatedJourneyNotificationsRouteImport } from './routes/_authenticated/journey.notifications'
import { Route as AuthenticatedJourneyMapRouteImport } from './routes/_authenticated/journey.map'
import { Route as AuthenticatedJourneyJournalRouteImport } from './routes/_authenticated/journey.journal'
import { Route as AuthenticatedJourneyChallengesRouteImport } from './routes/_authenticated/journey.challenges'
import { Route as AuthenticatedJourneyCertificatesRouteImport } from './routes/_authenticated/journey.certificates'
import { Route as AuthenticatedJourneyCalendarRouteImport } from './routes/_authenticated/journey.calendar'
import { Route as AuthenticatedJourneyAchievementsRouteImport } from './routes/_authenticated/journey.achievements'
import { Route as AuthenticatedAskIndexRouteImport } from './routes/_authenticated/ask.index'
import { Route as AuthenticatedAskThreadIdRouteImport } from './routes/_authenticated/ask.$threadId'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminWisdomRouteImport } from './routes/_authenticated/admin.wisdom'
import { Route as AuthenticatedAdminSubscriptionsRouteImport } from './routes/_authenticated/admin.subscriptions'
import { Route as AuthenticatedAdminShopRouteImport } from './routes/_authenticated/admin.shop'
import { Route as AuthenticatedAdminSecurityRouteImport } from './routes/_authenticated/admin.security'
import { Route as AuthenticatedAdminReleasesRouteImport } from './routes/_authenticated/admin.releases'
import { Route as AuthenticatedAdminPressRoomRouteImport } from './routes/_authenticated/admin.press-room'
import { Route as AuthenticatedAdminPipelineRouteImport } from './routes/_authenticated/admin.pipeline'
import { Route as AuthenticatedAdminOpsRouteImport } from './routes/_authenticated/admin.ops'
import { Route as AuthenticatedAdminModerationRouteImport } from './routes/_authenticated/admin.moderation'
import { Route as AuthenticatedAdminLibraryRouteImport } from './routes/_authenticated/admin.library'
import { Route as AuthenticatedAdminLaunchRouteImport } from './routes/_authenticated/admin.launch'
import { Route as AuthenticatedAdminKnowledgeRouteImport } from './routes/_authenticated/admin.knowledge'
import { Route as AuthenticatedAdminJourneyRouteImport } from './routes/_authenticated/admin.journey'
import { Route as AuthenticatedAdminIntelligenceRouteImport } from './routes/_authenticated/admin.intelligence'
import { Route as AuthenticatedAdminFeedbackRouteImport } from './routes/_authenticated/admin.feedback'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated/admin.events'
import { Route as AuthenticatedAdminEntitlementsRouteImport } from './routes/_authenticated/admin.entitlements'
import { Route as AuthenticatedAdminCustomersRouteImport } from './routes/_authenticated/admin.customers'
import { Route as AuthenticatedAdminCreatorRouteImport } from './routes/_authenticated/admin.creator'
import { Route as AuthenticatedAdminContentEngineRouteImport } from './routes/_authenticated/admin.content-engine'
import { Route as AuthenticatedAdminContentRouteImport } from './routes/_authenticated/admin.content'
import { Route as AuthenticatedAdminContactRouteImport } from './routes/_authenticated/admin.contact'
import { Route as AuthenticatedAdminCommerceRouteImport } from './routes/_authenticated/admin.commerce'
import { Route as AuthenticatedAdminBooksRouteImport } from './routes/_authenticated/admin.books'
import { Route as AuthenticatedAdminAuthorityRouteImport } from './routes/_authenticated/admin.authority'
import { Route as AuthenticatedAdminAuthEmailRouteImport } from './routes/_authenticated/admin.auth-email'
import { Route as AuthenticatedAdminAppReleasesRouteImport } from './routes/_authenticated/admin.app-releases'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin.analytics'
import { Route as AuthenticatedAdminActivationsRouteImport } from './routes/_authenticated/admin.activations'
import { Route as AuthenticatedAdminAcademyRouteImport } from './routes/_authenticated/admin.academy'
import { Route as MusicSlugSongSongRouteImport } from './routes/music.$slug.song.$song'
import { Route as AcademyKafrequencyDomainIndexRouteImport } from './routes/academy.kafrequency.$domain.index'
import { Route as AcademyDomainLessonLessonRouteImport } from './routes/academy.$domain.lesson.$lesson'
import { Route as AuthenticatedAcademyKafStudioRouteImport } from './routes/_authenticated/academy.kaf.studio'
import { Route as AuthenticatedAcademyKafProgressRouteImport } from './routes/_authenticated/academy.kaf.progress'
import { Route as AuthenticatedAcademyKafJourneyRouteImport } from './routes/_authenticated/academy.kaf.journey'
import { Route as AuthenticatedAcademyKafJournalRouteImport } from './routes/_authenticated/academy.kaf.journal'
import { Route as AuthenticatedAcademyKafDailyRouteImport } from './routes/_authenticated/academy.kaf.daily'
import { Route as AuthenticatedAdminBklsIndexRouteImport } from './routes/_authenticated/admin.bkls.index'
import { Route as AuthenticatedAdminBklsWizardRouteImport } from './routes/_authenticated/admin.bkls.wizard'
import { Route as AuthenticatedAdminBklsReadinessRouteImport } from './routes/_authenticated/admin.bkls.readiness'
import { Route as AuthenticatedAdminBklsPhase10RouteImport } from './routes/_authenticated/admin.bkls.phase10'
import { Route as AuthenticatedAdminBklsAuditRouteImport } from './routes/_authenticated/admin.bkls.audit'
import { Route as AuthenticatedAdminSecuritySettingsRouteImport } from './routes/_authenticated/admin.security.settings'
import { Route as AuthenticatedAdminModerationCommunityRouteImport } from './routes/_authenticated/admin.moderation.community'
import { Route as AcademyKafrequencyDomainLessonLessonRouteImport } from './routes/academy.kafrequency.$domain.lesson.$lesson'
import { Route as AuthenticatedAdminPreviewKindIdRouteImport } from './routes/_authenticated/admin.preview.$kind.$id'

const WisdomRoute = WisdomRouteImport.update({
            id: '/wisdom',path: '/wisdom',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const VisualsRoute = VisualsRouteImport.update({
            id: '/visuals',path: '/visuals',getParentRoute: () => rootRouteImport
          })
const TopicsRoute = TopicsRouteImport.update({
            id: '/topics',path: '/topics',getParentRoute: () => rootRouteImport
          })
const TimelineRoute = TimelineRouteImport.update({
            id: '/timeline',path: '/timeline',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PlanRoute = PlanRouteImport.update({
            id: '/plan',path: '/plan',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const MusicRoute = MusicRouteImport.update({
            id: '/music',path: '/music',getParentRoute: () => rootRouteImport
          })
const MethodRoute = MethodRouteImport.update({
            id: '/method',path: '/method',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const MediaRoute = MediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          })
const IntelligenceRoute = IntelligenceRouteImport.update({
            id: '/intelligence',path: '/intelligence',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const GatesRoute = GatesRouteImport.update({
            id: '/gates',path: '/gates',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const DownloadRoute = DownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConstellationRoute = ConstellationRouteImport.update({
            id: '/constellation',path: '/constellation',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const CodexRoute = CodexRouteImport.update({
            id: '/codex',path: '/codex',getParentRoute: () => rootRouteImport
          })
const CirclesRoute = CirclesRouteImport.update({
            id: '/circles',path: '/circles',getParentRoute: () => rootRouteImport
          })
const BooksRoute = BooksRouteImport.update({
            id: '/books',path: '/books',getParentRoute: () => rootRouteImport
          })
const BlueprintRoute = BlueprintRouteImport.update({
            id: '/blueprint',path: '/blueprint',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ActivationsRoute = ActivationsRouteImport.update({
            id: '/activations',path: '/activations',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AcademyRoute = AcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PressIndexRoute = PressIndexRouteImport.update({
            id: '/press/',path: '/press/',getParentRoute: () => rootRouteImport
          })
const PlaylistsIndexRoute = PlaylistsIndexRouteImport.update({
            id: '/playlists/',path: '/playlists/',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const ConceptsIndexRoute = ConceptsIndexRouteImport.update({
            id: '/concepts/',path: '/concepts/',getParentRoute: () => rootRouteImport
          })
const BeatsIndexRoute = BeatsIndexRouteImport.update({
            id: '/beats/',path: '/beats/',getParentRoute: () => rootRouteImport
          })
const VerifyCodeRoute = VerifyCodeRouteImport.update({
            id: '/verify/$code',path: '/verify/$code',getParentRoute: () => rootRouteImport
          })
const ReleaseSlugRoute = ReleaseSlugRouteImport.update({
            id: '/release/$slug',path: '/release/$slug',getParentRoute: () => rootRouteImport
          })
const PressFactsheetRoute = PressFactsheetRouteImport.update({
            id: '/press/factsheet',path: '/press/factsheet',getParentRoute: () => rootRouteImport
          })
const PlaylistsIdRoute = PlaylistsIdRouteImport.update({
            id: '/playlists/$id',path: '/playlists/$id',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const DebugSentryTestRoute = DebugSentryTestRouteImport.update({
            id: '/debug/sentry-test',path: '/debug/sentry-test',getParentRoute: () => rootRouteImport
          })
const ConceptsSlugRoute = ConceptsSlugRouteImport.update({
            id: '/concepts/$slug',path: '/concepts/$slug',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const BeatsLicenseRoute = BeatsLicenseRouteImport.update({
            id: '/beats/license',path: '/beats/license',getParentRoute: () => rootRouteImport
          })
const BeatsCustomRoute = BeatsCustomRouteImport.update({
            id: '/beats/custom',path: '/beats/custom',getParentRoute: () => rootRouteImport
          })
const BeatsCatalogRoute = BeatsCatalogRouteImport.update({
            id: '/beats/catalog',path: '/beats/catalog',getParentRoute: () => rootRouteImport
          })
const BeatsSlugRoute = BeatsSlugRouteImport.update({
            id: '/beats/$slug',path: '/beats/$slug',getParentRoute: () => rootRouteImport
          })
const ArtistBuddhaKaRoute = ArtistBuddhaKaRouteImport.update({
            id: '/artist/buddha-ka',path: '/artist/buddha-ka',getParentRoute: () => rootRouteImport
          })
const WisdomIndexRoute = WisdomIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WisdomRoute
          })
const WisdomSlugRoute = WisdomSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => WisdomRoute
          })
const TopicsIndexRoute = TopicsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TopicsRoute
          })
const TopicsSlugRoute = TopicsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => TopicsRoute
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ShopRoute
          })
const ShopSlugRoute = ShopSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ShopRoute
          })
const NewsletterConfirmRoute = NewsletterConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => NewsletterRoute
          })
const MusicIndexRoute = MusicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MusicRoute
          })
const MusicDiscographyRoute = MusicDiscographyRouteImport.update({
            id: '/discography',path: '/discography',getParentRoute: () => MusicRoute
          })
const MusicSlugRoute = MusicSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MusicRoute
          })
const MethodIndexRoute = MethodIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MethodRoute
          })
const MethodPillarRoute = MethodPillarRouteImport.update({
            id: '/$pillar',path: '/$pillar',getParentRoute: () => MethodRoute
          })
const MediaIndexRoute = MediaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MediaRoute
          })
const LibraryIndexRoute = LibraryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LibraryRoute
          })
const LibraryCategoryRoute = LibraryCategoryRouteImport.update({
            id: '/$category',path: '/$category',getParentRoute: () => LibraryRoute
          })
const GatesIndexRoute = GatesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GatesRoute
          })
const GatesMapRoute = GatesMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => GatesRoute
          })
const GatesNRoute = GatesNRouteImport.update({
            id: '/$n',path: '/$n',getParentRoute: () => GatesRoute
          })
const CodexIndexRoute = CodexIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CodexRoute
          })
const CodexSlugRoute = CodexSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CodexRoute
          })
const CirclesIndexRoute = CirclesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CirclesRoute
          })
const CirclesSlugRoute = CirclesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CirclesRoute
          })
const BooksIndexRoute = BooksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BooksRoute
          })
const BooksBibliographyRoute = BooksBibliographyRouteImport.update({
            id: '/bibliography',path: '/bibliography',getParentRoute: () => BooksRoute
          })
const BooksSlugRoute = BooksSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BooksRoute
          })
const ActivationsIndexRoute = ActivationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ActivationsRoute
          })
const ActivationsWheelRoute = ActivationsWheelRouteImport.update({
            id: '/wheel',path: '/wheel',getParentRoute: () => ActivationsRoute
          })
const ActivationsCalendarRoute = ActivationsCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => ActivationsRoute
          })
const ActivationsArchiveRoute = ActivationsArchiveRouteImport.update({
            id: '/archive',path: '/archive',getParentRoute: () => ActivationsRoute
          })
const ActivationsSlugRoute = ActivationsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ActivationsRoute
          })
const AcademyIndexRoute = AcademyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AcademyRoute
          })
const AcademyPremiumRoute = AcademyPremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => AcademyRoute
          })
const AcademyLibraryRoute = AcademyLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AcademyRoute
          })
const AcademyGraphRoute = AcademyGraphRouteImport.update({
            id: '/graph',path: '/graph',getParentRoute: () => AcademyRoute
          })
const AcademyDailyRoute = AcademyDailyRouteImport.update({
            id: '/daily',path: '/daily',getParentRoute: () => AcademyRoute
          })
const AcademyCommunityRoute = AcademyCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => AcademyRoute
          })
const AuthenticatedMeRoute = AuthenticatedMeRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLibraryRoute = AuthenticatedLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedJourneyRoute = AuthenticatedJourneyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDownloadsRoute = AuthenticatedDownloadsRouteImport.update({
            id: '/downloads',path: '/downloads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAskRoute = AuthenticatedAskRouteImport.update({
            id: '/ask',path: '/ask',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAscensionRoute = AuthenticatedAscensionRouteImport.update({
            id: '/ascension',path: '/ascension',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const PressTheDiamondSutraIndexRoute = PressTheDiamondSutraIndexRouteImport.update({
            id: '/press/the-diamond-sutra/',path: '/press/the-diamond-sutra/',getParentRoute: () => rootRouteImport
          })
const PressReleasesIndexRoute = PressReleasesIndexRouteImport.update({
            id: '/press/releases/',path: '/press/releases/',getParentRoute: () => rootRouteImport
          })
const BeatsCollectionsIndexRoute = BeatsCollectionsIndexRouteImport.update({
            id: '/beats/collections/',path: '/beats/collections/',getParentRoute: () => rootRouteImport
          })
const PressTheDiamondSutraListenRoute = PressTheDiamondSutraListenRouteImport.update({
            id: '/press/the-diamond-sutra/listen',path: '/press/the-diamond-sutra/listen',getParentRoute: () => rootRouteImport
          })
const PressKitSlugRoute = PressKitSlugRouteImport.update({
            id: '/press/kit/$slug',path: '/press/kit/$slug',getParentRoute: () => rootRouteImport
          })
const BeatsCollectionsSlugRoute = BeatsCollectionsSlugRouteImport.update({
            id: '/beats/collections/$slug',path: '/beats/collections/$slug',getParentRoute: () => rootRouteImport
          })
const MusicSlugIndexRoute = MusicSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MusicSlugRoute
          })
const LibraryReadSlugRoute = LibraryReadSlugRouteImport.update({
            id: '/read/$slug',path: '/read/$slug',getParentRoute: () => LibraryRoute
          })
const ActivationsSeriesSeriesRoute = ActivationsSeriesSeriesRouteImport.update({
            id: '/series/$series',path: '/series/$series',getParentRoute: () => ActivationsRoute
          })
const AcademyKafrequencyIndexRoute = AcademyKafrequencyIndexRouteImport.update({
            id: '/kafrequency/',path: '/kafrequency/',getParentRoute: () => AcademyRoute
          })
const AcademyDomainIndexRoute = AcademyDomainIndexRouteImport.update({
            id: '/$domain/',path: '/$domain/',getParentRoute: () => AcademyRoute
          })
const AcademyDomainPathRoute = AcademyDomainPathRouteImport.update({
            id: '/$domain/$path',path: '/$domain/$path',getParentRoute: () => AcademyRoute
          })
const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsPrivacyRoute = AuthenticatedSettingsPrivacyRouteImport.update({
            id: '/settings/privacy',path: '/settings/privacy',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsNotificationsRoute = AuthenticatedSettingsNotificationsRouteImport.update({
            id: '/settings/notifications',path: '/settings/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsMemoryRoute = AuthenticatedSettingsMemoryRouteImport.update({
            id: '/settings/memory',path: '/settings/memory',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBeatsAdminRoute = AuthenticatedBeatsAdminRouteImport.update({
            id: '/beats/admin',path: '/beats/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBeatsAccountRoute = AuthenticatedBeatsAccountRouteImport.update({
            id: '/beats/account',path: '/beats/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademySavedRoute = AuthenticatedAcademySavedRouteImport.update({
            id: '/academy/saved',path: '/academy/saved',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyJournalRoute = AuthenticatedAcademyJournalRouteImport.update({
            id: '/academy/journal',path: '/academy/journal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyDashboardRoute = AuthenticatedAcademyDashboardRouteImport.update({
            id: '/academy/dashboard',path: '/academy/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyAiGuideRoute = AuthenticatedAcademyAiGuideRouteImport.update({
            id: '/academy/ai-guide',path: '/academy/ai-guide',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedJourneyIndexRoute = AuthenticatedJourneyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyTimelineRoute = AuthenticatedJourneyTimelineRouteImport.update({
            id: '/timeline',path: '/timeline',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyTempleRoute = AuthenticatedJourneyTempleRouteImport.update({
            id: '/temple',path: '/temple',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyNotificationsRoute = AuthenticatedJourneyNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyMapRoute = AuthenticatedJourneyMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyJournalRoute = AuthenticatedJourneyJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyChallengesRoute = AuthenticatedJourneyChallengesRouteImport.update({
            id: '/challenges',path: '/challenges',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyCertificatesRoute = AuthenticatedJourneyCertificatesRouteImport.update({
            id: '/certificates',path: '/certificates',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyCalendarRoute = AuthenticatedJourneyCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedJourneyAchievementsRoute = AuthenticatedJourneyAchievementsRouteImport.update({
            id: '/achievements',path: '/achievements',getParentRoute: () => AuthenticatedJourneyRoute
          })
const AuthenticatedAskIndexRoute = AuthenticatedAskIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAskRoute
          })
const AuthenticatedAskThreadIdRoute = AuthenticatedAskThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => AuthenticatedAskRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWisdomRoute = AuthenticatedAdminWisdomRouteImport.update({
            id: '/wisdom',path: '/wisdom',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSubscriptionsRoute = AuthenticatedAdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminShopRoute = AuthenticatedAdminShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSecurityRoute = AuthenticatedAdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReleasesRoute = AuthenticatedAdminReleasesRouteImport.update({
            id: '/releases',path: '/releases',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPressRoomRoute = AuthenticatedAdminPressRoomRouteImport.update({
            id: '/press-room',path: '/press-room',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPipelineRoute = AuthenticatedAdminPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOpsRoute = AuthenticatedAdminOpsRouteImport.update({
            id: '/ops',path: '/ops',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminModerationRoute = AuthenticatedAdminModerationRouteImport.update({
            id: '/moderation',path: '/moderation',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLibraryRoute = AuthenticatedAdminLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLaunchRoute = AuthenticatedAdminLaunchRouteImport.update({
            id: '/launch',path: '/launch',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminKnowledgeRoute = AuthenticatedAdminKnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminJourneyRoute = AuthenticatedAdminJourneyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntelligenceRoute = AuthenticatedAdminIntelligenceRouteImport.update({
            id: '/intelligence',path: '/intelligence',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFeedbackRoute = AuthenticatedAdminFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEventsRoute = AuthenticatedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEntitlementsRoute = AuthenticatedAdminEntitlementsRouteImport.update({
            id: '/entitlements',path: '/entitlements',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCustomersRoute = AuthenticatedAdminCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCreatorRoute = AuthenticatedAdminCreatorRouteImport.update({
            id: '/creator',path: '/creator',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentEngineRoute = AuthenticatedAdminContentEngineRouteImport.update({
            id: '/content-engine',path: '/content-engine',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentRoute = AuthenticatedAdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactRoute = AuthenticatedAdminContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCommerceRoute = AuthenticatedAdminCommerceRouteImport.update({
            id: '/commerce',path: '/commerce',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBooksRoute = AuthenticatedAdminBooksRouteImport.update({
            id: '/books',path: '/books',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuthorityRoute = AuthenticatedAdminAuthorityRouteImport.update({
            id: '/authority',path: '/authority',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuthEmailRoute = AuthenticatedAdminAuthEmailRouteImport.update({
            id: '/auth-email',path: '/auth-email',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAppReleasesRoute = AuthenticatedAdminAppReleasesRouteImport.update({
            id: '/app-releases',path: '/app-releases',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminActivationsRoute = AuthenticatedAdminActivationsRouteImport.update({
            id: '/activations',path: '/activations',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAcademyRoute = AuthenticatedAdminAcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => AuthenticatedAdminRoute
          })
const MusicSlugSongSongRoute = MusicSlugSongSongRouteImport.update({
            id: '/song/$song',path: '/song/$song',getParentRoute: () => MusicSlugRoute
          })
const AcademyKafrequencyDomainIndexRoute = AcademyKafrequencyDomainIndexRouteImport.update({
            id: '/kafrequency/$domain/',path: '/kafrequency/$domain/',getParentRoute: () => AcademyRoute
          })
const AcademyDomainLessonLessonRoute = AcademyDomainLessonLessonRouteImport.update({
            id: '/$domain/lesson/$lesson',path: '/$domain/lesson/$lesson',getParentRoute: () => AcademyRoute
          })
const AuthenticatedAcademyKafStudioRoute = AuthenticatedAcademyKafStudioRouteImport.update({
            id: '/academy/kaf/studio',path: '/academy/kaf/studio',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyKafProgressRoute = AuthenticatedAcademyKafProgressRouteImport.update({
            id: '/academy/kaf/progress',path: '/academy/kaf/progress',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyKafJourneyRoute = AuthenticatedAcademyKafJourneyRouteImport.update({
            id: '/academy/kaf/journey',path: '/academy/kaf/journey',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyKafJournalRoute = AuthenticatedAcademyKafJournalRouteImport.update({
            id: '/academy/kaf/journal',path: '/academy/kaf/journal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAcademyKafDailyRoute = AuthenticatedAcademyKafDailyRouteImport.update({
            id: '/academy/kaf/daily',path: '/academy/kaf/daily',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminBklsIndexRoute = AuthenticatedAdminBklsIndexRouteImport.update({
            id: '/bkls/',path: '/bkls/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBklsWizardRoute = AuthenticatedAdminBklsWizardRouteImport.update({
            id: '/bkls/wizard',path: '/bkls/wizard',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBklsReadinessRoute = AuthenticatedAdminBklsReadinessRouteImport.update({
            id: '/bkls/readiness',path: '/bkls/readiness',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBklsPhase10Route = AuthenticatedAdminBklsPhase10RouteImport.update({
            id: '/bkls/phase10',path: '/bkls/phase10',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBklsAuditRoute = AuthenticatedAdminBklsAuditRouteImport.update({
            id: '/bkls/audit',path: '/bkls/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSecuritySettingsRoute = AuthenticatedAdminSecuritySettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminSecurityRoute
          })
const AuthenticatedAdminModerationCommunityRoute = AuthenticatedAdminModerationCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => AuthenticatedAdminModerationRoute
          })
const AcademyKafrequencyDomainLessonLessonRoute = AcademyKafrequencyDomainLessonLessonRouteImport.update({
            id: '/kafrequency/$domain/lesson/$lesson',path: '/kafrequency/$domain/lesson/$lesson',getParentRoute: () => AcademyRoute
          })
const AuthenticatedAdminPreviewKindIdRoute = AuthenticatedAdminPreviewKindIdRouteImport.update({
            id: '/preview/$kind/$id',path: '/preview/$kind/$id',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminModerationRouteChildren = {
  AuthenticatedAdminModerationCommunityRoute: AuthenticatedAdminModerationCommunityRoute
}

const AuthenticatedAdminModerationRouteWithChildren = AuthenticatedAdminModerationRoute._addFileChildren(AuthenticatedAdminModerationRouteChildren)




const AuthenticatedAdminSecurityRouteChildren = {
  AuthenticatedAdminSecuritySettingsRoute: AuthenticatedAdminSecuritySettingsRoute
}

const AuthenticatedAdminSecurityRouteWithChildren = AuthenticatedAdminSecurityRoute._addFileChildren(AuthenticatedAdminSecurityRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAcademyRoute: AuthenticatedAdminAcademyRoute,AuthenticatedAdminActivationsRoute: AuthenticatedAdminActivationsRoute,AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminAppReleasesRoute: AuthenticatedAdminAppReleasesRoute,AuthenticatedAdminAuthEmailRoute: AuthenticatedAdminAuthEmailRoute,AuthenticatedAdminAuthorityRoute: AuthenticatedAdminAuthorityRoute,AuthenticatedAdminBooksRoute: AuthenticatedAdminBooksRoute,AuthenticatedAdminCommerceRoute: AuthenticatedAdminCommerceRoute,AuthenticatedAdminContactRoute: AuthenticatedAdminContactRoute,AuthenticatedAdminContentRoute: AuthenticatedAdminContentRoute,AuthenticatedAdminContentEngineRoute: AuthenticatedAdminContentEngineRoute,AuthenticatedAdminCreatorRoute: AuthenticatedAdminCreatorRoute,AuthenticatedAdminCustomersRoute: AuthenticatedAdminCustomersRoute,AuthenticatedAdminEntitlementsRoute: AuthenticatedAdminEntitlementsRoute,AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,AuthenticatedAdminFeedbackRoute: AuthenticatedAdminFeedbackRoute,AuthenticatedAdminIntelligenceRoute: AuthenticatedAdminIntelligenceRoute,AuthenticatedAdminJourneyRoute: AuthenticatedAdminJourneyRoute,AuthenticatedAdminKnowledgeRoute: AuthenticatedAdminKnowledgeRoute,AuthenticatedAdminLaunchRoute: AuthenticatedAdminLaunchRoute,AuthenticatedAdminLibraryRoute: AuthenticatedAdminLibraryRoute,AuthenticatedAdminModerationRoute: AuthenticatedAdminModerationRouteWithChildren,AuthenticatedAdminOpsRoute: AuthenticatedAdminOpsRoute,AuthenticatedAdminPipelineRoute: AuthenticatedAdminPipelineRoute,AuthenticatedAdminPressRoomRoute: AuthenticatedAdminPressRoomRoute,AuthenticatedAdminReleasesRoute: AuthenticatedAdminReleasesRoute,AuthenticatedAdminSecurityRoute: AuthenticatedAdminSecurityRouteWithChildren,AuthenticatedAdminShopRoute: AuthenticatedAdminShopRoute,AuthenticatedAdminSubscriptionsRoute: AuthenticatedAdminSubscriptionsRoute,AuthenticatedAdminWisdomRoute: AuthenticatedAdminWisdomRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminBklsAuditRoute: AuthenticatedAdminBklsAuditRoute,AuthenticatedAdminBklsPhase10Route: AuthenticatedAdminBklsPhase10Route,AuthenticatedAdminBklsReadinessRoute: AuthenticatedAdminBklsReadinessRoute,AuthenticatedAdminBklsWizardRoute: AuthenticatedAdminBklsWizardRoute,AuthenticatedAdminBklsIndexRoute: AuthenticatedAdminBklsIndexRoute,AuthenticatedAdminPreviewKindIdRoute: AuthenticatedAdminPreviewKindIdRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedAskRouteChildren = {
  AuthenticatedAskThreadIdRoute: AuthenticatedAskThreadIdRoute,AuthenticatedAskIndexRoute: AuthenticatedAskIndexRoute
}

const AuthenticatedAskRouteWithChildren = AuthenticatedAskRoute._addFileChildren(AuthenticatedAskRouteChildren)




const AuthenticatedJourneyRouteChildren = {
  AuthenticatedJourneyAchievementsRoute: AuthenticatedJourneyAchievementsRoute,AuthenticatedJourneyCalendarRoute: AuthenticatedJourneyCalendarRoute,AuthenticatedJourneyCertificatesRoute: AuthenticatedJourneyCertificatesRoute,AuthenticatedJourneyChallengesRoute: AuthenticatedJourneyChallengesRoute,AuthenticatedJourneyJournalRoute: AuthenticatedJourneyJournalRoute,AuthenticatedJourneyMapRoute: AuthenticatedJourneyMapRoute,AuthenticatedJourneyNotificationsRoute: AuthenticatedJourneyNotificationsRoute,AuthenticatedJourneyTempleRoute: AuthenticatedJourneyTempleRoute,AuthenticatedJourneyTimelineRoute: AuthenticatedJourneyTimelineRoute,AuthenticatedJourneyIndexRoute: AuthenticatedJourneyIndexRoute
}

const AuthenticatedJourneyRouteWithChildren = AuthenticatedJourneyRoute._addFileChildren(AuthenticatedJourneyRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedAscensionRoute: AuthenticatedAscensionRoute,AuthenticatedAskRoute: AuthenticatedAskRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDownloadsRoute: AuthenticatedDownloadsRoute,AuthenticatedJourneyRoute: AuthenticatedJourneyRouteWithChildren,AuthenticatedLibraryRoute: AuthenticatedLibraryRoute,AuthenticatedMeRoute: AuthenticatedMeRoute,AuthenticatedAcademyAiGuideRoute: AuthenticatedAcademyAiGuideRoute,AuthenticatedAcademyDashboardRoute: AuthenticatedAcademyDashboardRoute,AuthenticatedAcademyJournalRoute: AuthenticatedAcademyJournalRoute,AuthenticatedAcademySavedRoute: AuthenticatedAcademySavedRoute,AuthenticatedBeatsAccountRoute: AuthenticatedBeatsAccountRoute,AuthenticatedBeatsAdminRoute: AuthenticatedBeatsAdminRoute,AuthenticatedSettingsMemoryRoute: AuthenticatedSettingsMemoryRoute,AuthenticatedSettingsNotificationsRoute: AuthenticatedSettingsNotificationsRoute,AuthenticatedSettingsPrivacyRoute: AuthenticatedSettingsPrivacyRoute,AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,AuthenticatedAcademyKafDailyRoute: AuthenticatedAcademyKafDailyRoute,AuthenticatedAcademyKafJournalRoute: AuthenticatedAcademyKafJournalRoute,AuthenticatedAcademyKafJourneyRoute: AuthenticatedAcademyKafJourneyRoute,AuthenticatedAcademyKafProgressRoute: AuthenticatedAcademyKafProgressRoute,AuthenticatedAcademyKafStudioRoute: AuthenticatedAcademyKafStudioRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AcademyRouteChildren = {
  AcademyCommunityRoute: AcademyCommunityRoute,AcademyDailyRoute: AcademyDailyRoute,AcademyGraphRoute: AcademyGraphRoute,AcademyLibraryRoute: AcademyLibraryRoute,AcademyPremiumRoute: AcademyPremiumRoute,AcademyIndexRoute: AcademyIndexRoute,AcademyDomainPathRoute: AcademyDomainPathRoute,AcademyDomainIndexRoute: AcademyDomainIndexRoute,AcademyKafrequencyIndexRoute: AcademyKafrequencyIndexRoute,AcademyDomainLessonLessonRoute: AcademyDomainLessonLessonRoute,AcademyKafrequencyDomainIndexRoute: AcademyKafrequencyDomainIndexRoute,AcademyKafrequencyDomainLessonLessonRoute: AcademyKafrequencyDomainLessonLessonRoute
}

const AcademyRouteWithChildren = AcademyRoute._addFileChildren(AcademyRouteChildren)




const ActivationsRouteChildren = {
  ActivationsSlugRoute: ActivationsSlugRoute,ActivationsArchiveRoute: ActivationsArchiveRoute,ActivationsCalendarRoute: ActivationsCalendarRoute,ActivationsWheelRoute: ActivationsWheelRoute,ActivationsIndexRoute: ActivationsIndexRoute,ActivationsSeriesSeriesRoute: ActivationsSeriesSeriesRoute
}

const ActivationsRouteWithChildren = ActivationsRoute._addFileChildren(ActivationsRouteChildren)




const BooksRouteChildren = {
  BooksSlugRoute: BooksSlugRoute,BooksBibliographyRoute: BooksBibliographyRoute,BooksIndexRoute: BooksIndexRoute
}

const BooksRouteWithChildren = BooksRoute._addFileChildren(BooksRouteChildren)




const CirclesRouteChildren = {
  CirclesSlugRoute: CirclesSlugRoute,CirclesIndexRoute: CirclesIndexRoute
}

const CirclesRouteWithChildren = CirclesRoute._addFileChildren(CirclesRouteChildren)




const CodexRouteChildren = {
  CodexSlugRoute: CodexSlugRoute,CodexIndexRoute: CodexIndexRoute
}

const CodexRouteWithChildren = CodexRoute._addFileChildren(CodexRouteChildren)




const GatesRouteChildren = {
  GatesNRoute: GatesNRoute,GatesMapRoute: GatesMapRoute,GatesIndexRoute: GatesIndexRoute
}

const GatesRouteWithChildren = GatesRoute._addFileChildren(GatesRouteChildren)




const LibraryRouteChildren = {
  LibraryCategoryRoute: LibraryCategoryRoute,LibraryIndexRoute: LibraryIndexRoute,LibraryReadSlugRoute: LibraryReadSlugRoute
}

const LibraryRouteWithChildren = LibraryRoute._addFileChildren(LibraryRouteChildren)




const MediaRouteChildren = {
  MediaIndexRoute: MediaIndexRoute
}

const MediaRouteWithChildren = MediaRoute._addFileChildren(MediaRouteChildren)




const MethodRouteChildren = {
  MethodPillarRoute: MethodPillarRoute,MethodIndexRoute: MethodIndexRoute
}

const MethodRouteWithChildren = MethodRoute._addFileChildren(MethodRouteChildren)




const MusicSlugRouteChildren = {
  MusicSlugIndexRoute: MusicSlugIndexRoute,MusicSlugSongSongRoute: MusicSlugSongSongRoute
}

const MusicSlugRouteWithChildren = MusicSlugRoute._addFileChildren(MusicSlugRouteChildren)



const MusicRouteChildren = {
  MusicSlugRoute: MusicSlugRouteWithChildren,MusicDiscographyRoute: MusicDiscographyRoute,MusicIndexRoute: MusicIndexRoute
}

const MusicRouteWithChildren = MusicRoute._addFileChildren(MusicRouteChildren)




const NewsletterRouteChildren = {
  NewsletterConfirmRoute: NewsletterConfirmRoute
}

const NewsletterRouteWithChildren = NewsletterRoute._addFileChildren(NewsletterRouteChildren)




const ShopRouteChildren = {
  ShopSlugRoute: ShopSlugRoute,ShopIndexRoute: ShopIndexRoute
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)




const TopicsRouteChildren = {
  TopicsSlugRoute: TopicsSlugRoute,TopicsIndexRoute: TopicsIndexRoute
}

const TopicsRouteWithChildren = TopicsRoute._addFileChildren(TopicsRouteChildren)




const WisdomRouteChildren = {
  WisdomSlugRoute: WisdomSlugRoute,WisdomIndexRoute: WisdomIndexRoute
}

const WisdomRouteWithChildren = WisdomRoute._addFileChildren(WisdomRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AcademyRoute: AcademyRouteWithChildren,AccessibilityRoute: AccessibilityRoute,AccountRoute: AccountRoute,ActivationsRoute: ActivationsRouteWithChildren,AuthRoute: AuthRoute,BlueprintRoute: BlueprintRoute,BooksRoute: BooksRouteWithChildren,CirclesRoute: CirclesRouteWithChildren,CodexRoute: CodexRouteWithChildren,CommunityRoute: CommunityRoute,ConstellationRoute: ConstellationRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DownloadRoute: DownloadRoute,EventsRoute: EventsRoute,GatesRoute: GatesRouteWithChildren,GlossaryRoute: GlossaryRoute,IntelligenceRoute: IntelligenceRoute,LibraryRoute: LibraryRouteWithChildren,MapRoute: MapRoute,MediaRoute: MediaRouteWithChildren,MembershipRoute: MembershipRoute,MethodRoute: MethodRouteWithChildren,MusicRoute: MusicRouteWithChildren,NewsletterRoute: NewsletterRouteWithChildren,PlanRoute: PlanRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,SearchRoute: SearchRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRouteWithChildren,StartRoute: StartRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,TimelineRoute: TimelineRoute,TopicsRoute: TopicsRouteWithChildren,VisualsRoute: VisualsRoute,WelcomeRoute: WelcomeRoute,WisdomRoute: WisdomRouteWithChildren,ArtistBuddhaKaRoute: ArtistBuddhaKaRoute,BeatsSlugRoute: BeatsSlugRoute,BeatsCatalogRoute: BeatsCatalogRoute,BeatsCustomRoute: BeatsCustomRoute,BeatsLicenseRoute: BeatsLicenseRoute,CheckoutReturnRoute: CheckoutReturnRoute,ConceptsSlugRoute: ConceptsSlugRoute,DebugSentryTestRoute: DebugSentryTestRoute,NewsSlugRoute: NewsSlugRoute,PlaylistsIdRoute: PlaylistsIdRoute,PressFactsheetRoute: PressFactsheetRoute,ReleaseSlugRoute: ReleaseSlugRoute,VerifyCodeRoute: VerifyCodeRoute,BeatsIndexRoute: BeatsIndexRoute,ConceptsIndexRoute: ConceptsIndexRoute,NewsIndexRoute: NewsIndexRoute,PlaylistsIndexRoute: PlaylistsIndexRoute,PressIndexRoute: PressIndexRoute,BeatsCollectionsSlugRoute: BeatsCollectionsSlugRoute,PressKitSlugRoute: PressKitSlugRoute,PressTheDiamondSutraListenRoute: PressTheDiamondSutraListenRoute,BeatsCollectionsIndexRoute: BeatsCollectionsIndexRoute,PressReleasesIndexRoute: PressReleasesIndexRoute,PressTheDiamondSutraIndexRoute: PressTheDiamondSutraIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)